import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Genrals Emitidos
    genralsEmit: {
      tableData: [],
      totalGenralsEmit: 0
    },
    queryGenralsEmit: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersGenralsEmit: [],

    // Genrals Recibidos
    genralsReceived: {
      tableData: [],
      totalGenralsReceived: 0
    },
    queryGenralsReceived: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'RECEIVED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersGenralsReceived: [],
    // Combo estados genrals
    optionsFilterStatusGenral: [],

    // Datos Select Filtros Genrals Emitidos
    optionsFilterBuyerGenralEmit: [],
    optionsFilterSellerGenralEmit: [],
    optionsFilterDateCreationGenralEmit: [],
    optionsFilterDateIssueGenralEmit: [],
    optionsFilterGenralNumberGenralEmit: [],
    optionsFilterDescriptionGenralEmit: [],
    // Datos Select Filtros Genrals Recibidos
    optionsFilterBuyerGenralReceived: [],
    optionsFilterSellerGenralReceived: [],
    optionsFilterDateCreationGenralReceived: [],
    optionsFilterDateIssueGenralReceived: [],
    optionsFilterGenralNumberGenralReceived: [],
    optionsFilterDescriptionGenralReceived: []
  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Genrals Emitidos
    isShowBuyerGenralEmit: true,
    isShowSellerGenralEmit: true,
    isShowNumGenralEmit: false,
    isShowDescriptionGenralEmit: true,
    isShowDateCreationGenralEmit: true,
    isShowDateIssueGenralEmit: true,
    isShowStatusGenralEmit: true,
    isShowServiceGenralEmit: true,

    // Columnas Tabla Genrals Recibidos
    isShowBuyerGenralReceived: true,
    isShowSellerGenralReceived: true,
    isShowNumGenralReceived: false,
    isShowDescriptionGenralReceived: true,
    isShowDateCreationGenralReceived: true,
    isShowDateIssueGenralReceived: true,
    isShowStatusGenralReceived: true,
    isShowServiceGenralReceived: true,
    isShowRecepcionGenralReceived: true
  }
  return local
}
function setByUserLocalGenral () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals) {
    const local = {
      
      // Columnas Tabla Genrals Emitidos
      isShowBuyerGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowBuyerGenralEmit,
      isShowSellerGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowSellerGenralEmit,
      isShowNumGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowNumGenralEmit,
      isShowDescriptionGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowDescriptionGenralEmit,
      isShowDateCreationGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowDateCreationGenralEmit,
      isShowDateIssueGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowDateIssueGenralEmit,
      isShowStatusGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowStatusGenralEmit,
      isShowServiceGenralEmit: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowServiceGenralEmit,

      // Columnas Tabla Genrals Recibidos
      isShowBuyerGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowBuyerGenralReceived,
      isShowSellerGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowSellerGenralReceived,
      isShowNumGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowNumGenralReceived,
      isShowDescriptionGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowDescriptionGenralReceived,
      isShowDateCreationGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowDateCreationGenralReceived,
      isShowDateIssueGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowDateIssueGenralReceived,
      isShowStatusGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowStatusGenralReceived,
      isShowServiceGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowServiceGenralReceived,
      isShowRecepcionGenralReceived: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).genrals.isShowRecepcionGenralReceived
    }
    return local
  } else {
    return initLocal()
  }
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Genrals Emitidos
    isShowBuyerGenralEmit: true,
    isShowSellerGenralEmit: true,
    isShowNumGenralEmit: false,
    isShowDescriptionGenralEmit: true,
    isShowDateCreationGenralEmit: true,
    isShowDateIssueGenralEmit: true,
    isShowStatusGenralEmit: true,
    isShowServiceGenralEmit: true,

    // Columnas Tabla Genrals Recibidos
    isShowBuyerGenralReceived: true,
    isShowSellerGenralReceived: true,
    isShowNumGenralReceived: false,
    isShowDescriptionGenralReceived: true,
    isShowDateCreationGenralReceived: true,
    isShowDateIssueGenralReceived: true,
    isShowStatusGenralReceived: true,
    isShowServiceGenralReceived: true,
    isShowRecepcionGenralReceived: true
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla Genrals Emitidos
  genralsEmit: state => {
    return state.session.genralsEmit
  },
  queryGenralsEmit: state => {
    return state.session.queryGenralsEmit
  },
  listSelectedFiltersGenralsEmit: state => {
    return state.session.listSelectedFiltersGenralsEmit
  },

  // Datos Tabla Genrals Recibidos
  genralsReceived: state => {
    return state.session.genralsReceived
  },
  queryGenralsReceived: state => {
    return state.session.queryGenralsReceived
  },
  listSelectedFiltersGenralsReceived: state => {
    return state.session.listSelectedFiltersGenralsReceived
  },

  // Datos Select Filtros Genrals Emitidos
  optionsFilterBuyerGenralEmit: state => {
    return state.session.optionsFilterBuyerGenralEmit
  },
  optionsFilterSellerGenralEmit: state => {
    return state.session.optionsFilterSellerGenralEmit
  },
  optionsFilterDateCreationGenralEmit: state => {
    return state.session.optionsFilterDateCreationGenralEmit
  },
  optionsFilterDateIssueGenralEmit: state => {
    return state.session.optionsFilterDateIssueGenralEmit
  },
  optionsFilterGenralNumberGenralEmit: state => {
    return state.session.optionsFilterGenralNumberGenralEmit
  },
  optionsFilterDescriptionGenralEmit: state => {
    return state.session.optionsFilterDescriptionGenralEmit
  },
  // Datos Select Filtros Genrals Recibidos
  optionsFilterBuyerGenralReceived: state => {
    return state.session.optionsFilterBuyerGenralReceived
  },
  optionsFilterSellerGenralReceived: state => {
    return state.session.optionsFilterSellerGenralReceived
  },
  optionsFilterDateCreationGenralReceived: state => {
    return state.session.optionsFilterDateCreationGenralReceived
  },
  optionsFilterDateIssueGenralReceived: state => {
    return state.session.optionsFilterDateIssueGenralReceived
  },
  optionsFilterGenralNumberGenralReceived: state => {
    return state.session.optionsFilterGenralNumberGenralReceived
  },
  optionsFilterDescriptionGenralReceived: state => {
    return state.session.optionsFilterDescriptionGenralReceived
  },
  // Combo estados
  optionsFilterStatusGenral: state => {
    return state.session.optionsFilterStatusGenral
  },
  // Columnas Tabla Genrals Emitidos
  isShowBuyerGenralEmit: state => {
    return state.local.isShowBuyerGenralEmit
  },
  isShowSellerGenralEmit: state => {
    return state.local.isShowSellerGenralEmit
  },
  isShowNumGenralEmit: state => {
    return state.local.isShowNumGenralEmit
  },
  isShowDescriptionGenralEmit: state => {
    return state.local.isShowDescriptionGenralEmit
  },
  isShowDateCreationGenralEmit: state => {
    return state.local.isShowDateCreationGenralEmit
  },
  isShowDateIssueGenralEmit: state => {
    return state.local.isShowDateIssueGenralEmit
  },
  isShowStatusGenralEmit: state => {
    return state.local.isShowStatusGenralEmit
  },
  isShowServiceGenralEmit: state => {
    return state.local.isShowServiceGenralEmit
  },
  // Columnas Tabla Genrals Recibidos
  isShowBuyerGenralReceived: state => {
    return state.local.isShowBuyerGenralReceived
  },
  isShowSellerGenralReceived: state => {
    return state.local.isShowSellerGenralReceived
  },
  isShowNumGenralReceived: state => {
    return state.local.isShowNumGenralReceived
  },
  isShowDescriptionGenralReceived: state => {
    return state.local.isShowDescriptionGenralReceived
  },
  isShowDateCreationGenralReceived: state => {
    return state.local.isShowDateCreationGenralReceived
  },
  isShowDateIssueGenralReceived: state => {
    return state.local.isShowDateIssueGenralReceived
  },
  isShowStatusGenralReceived: state => {
    return state.local.isShowStatusGenralReceived
  },
  isShowServiceGenralReceived: state => {
    return state.local.isShowServiceGenralReceived
  },
  isShowRecepcionGenralReceived: state => {
    return state.local.isShowRecepcionGenralReceived
  }
}

// actions
const actions = {
  // Crear key Usuario
  // Crear key Usuario
  setUserNameGenral ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalGenral()
    }
  },
  async isNewVersionGenralsLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.genrals)
    return isnew
  },

  /* GENRALS */
  /**
  * Servicio para traer las genrals Emitidos y Recibidos .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getGenrals ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/genral',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      commit('GENRALS_EMIT_STATE', {
        tableData: response.data.content,
        totalGenralsEmit: response.data.totalElements
      })

      commit('GENRALS_RECEIVED_STATE', {
        tableData: response.data.content,
        totalGenralsReceived: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de una genral
  async getGenralDetail ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/genral/' + params.genralID,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
 * Servicio para descargar pdf de una Recepción
 * @param {*} genralId
 */
  async downloadGenralPdf ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/genral/' + params.genralId + '/pdf',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'genral.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los tipos de estados de las genrals Emitidos y Recibidos
   */
  async getOptionsFilterStatusGenral ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/genralstatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterStatusGenral = response.data
      commit('OPTIONS_FILTER_STATUS_GENRALS', optionsFilterStatusGenral)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterStatusGenral
    } catch (error) {
      console.log('status genral : ', error)
      throw error.response
    }
  },
  /**
     * Servicio para Exportar Todas las Genrals  a CSV
     */
  async downloadGenralCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/genral/csv',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'genrals.csv'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla Genrals Emitidos
  genralsEmitState: ({ commit }, payload) => {
    commit('GENRALS_EMIT_STATE', payload)
  },
  queryGenralsEmitState: ({ commit }, payload) => {
    commit('QUERY_GENRALS_EMIT_STATE', payload)
  },
  listSelectedFiltersGenralsEmitState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_GENRALS_EMIT_STATE', payload)
  },

  // Datos Tabla Genrals Recibidos
  genralsReceivedState: ({ commit }, payload) => {
    commit('GENRALS_RECEIVED_STATE', payload)
  },
  queryGenralsReceivedState: ({ commit }, payload) => {
    commit('QUERY_GENRALS_RECEIVED_STATE', payload)
  },
  listSelectedFiltersGenralsReceivedState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_GENRALS_RECEIVED_STATE', payload)
  },

  // Datos Select Filtros Genrals Emitidos
  optionsFilterBuyerGenralEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_GENRALS_EMIT', payload)
  },
  optionsFilterSellerGenralEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_GENRALS_EMIT', payload)
  },
  optionsFilterDateCreationGenralEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_GENRALS_EMIT', payload)
  },
  optionsFilterDateIssueGenralEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_GENRALS_EMIT', payload)
  },
  optionsFilterGenralNumberGenralEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_GENRAL_NUMBER_GENRALS_EMIT', payload)
  },
  optionsFilterDescriptionGenralEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DESCRIPTION_GENRALS_EMIT', payload)
  },
  // Datos Select Filtros Genrals Recibidos
  optionsFilterBuyerGenralReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_BUYER_GENRALS_RECEIVED', payload)
  },
  optionsFilterSellerGenralReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SELLER_GENRALS_RECEIVED', payload)
  },
  optionsFilterDateCreationGenralReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_GENRALS_RECEIVED', payload)
  },
  optionsFilterDateIssueGenralReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_GENRALS_RECEIVED', payload)
  },
  optionsFilterGenralNumberGenralReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_GENRAL_NUMBER_GENRALS_RECEIVED', payload)
  },
  optionsFilterDescriptionGenralReceivedState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DESCRIPTION_GENRALS_RECEIVED', payload)
  },

  // Combo estados
  optionsFilterStatusGenralState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STATUS_GENRALS', payload)
  },

  // Columnas Tabla Genrals Emitidos
  isShowBuyerGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_GENRAL_EMIT', payload)
  },
  isShowSellerGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_GENRAL_EMIT', payload)
  },
  isShowNumGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_GENRAL_EMIT', payload)
  },
  isShowDescriptionGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_EMIT', payload)
  },
  isShowDateCreationGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_GENRAL_EMIT', payload)
  },
  isShowDateIssueGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_GENRAL_EMIT', payload)
  },
  isShowStatusGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_GENRAL_EMIT', payload)
  },
  isShowServiceGenralEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_GENRAL_EMIT', payload)
  },

  // Columnas Tabla Genrals Recibidos
  isShowBuyerGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_GENRAL_RECEIVED', payload)
  },
  isShowSellerGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_GENRAL_RECEIVED', payload)
  },
  isShowNumGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUM_GENRAL_RECEIVED', payload)
  },
  isShowDescriptionGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DESCRIPTION_RECEIVED', payload)
  },
  isShowDateCreationGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_CREATION_GENRAL_RECEIVED', payload)
  },
  isShowDateIssueGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_DATE_ISSUE_GENRAL_RECEIVED', payload)
  },
  isShowStatusGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_GENRAL_RECEIVED', payload)
  },
  isShowServiceGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_GENRAL_RECEIVED', payload)
  },
  isShowRecepcionGenralReceivedAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEPTION_GENRAL_RECEIVED', payload)
  }
}

// mutations
const mutations = {
  resetSessionGenrals (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  genralDatesSuperAdmin (state) {
    state.session.queryGenralsEmit.creationDateTimeFrom = fn.initDateFrom(1)
    state.session.queryGenralsReceived.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Genrals Emitidos
  'GENRALS_EMIT_STATE' (state, payload) {
    state.session.genralsEmit = payload
  },
  'QUERY_GENRALS_EMIT_STATE' (state, payload) {
    state.session.queryGenralsEmit = payload
  },
  'LIST_SELECTED_FILTERS_GENRALS_EMIT_STATE' (state, payload) {
    state.session.listSelectedFiltersGenralsEmit = payload
  },

  // Genrals Recibidos
  'GENRALS_RECEIVED_STATE' (state, payload) {
    state.session.genralsReceived = payload
  },
  'QUERY_GENRALS_RECEIVED_STATE' (state, payload) {
    state.session.queryGenralsReceived = payload
  },
  'LIST_SELECTED_FILTERS_GENRALS_RECEIVED_STATE' (state, payload) {
    state.session.listSelectedFiltersGenralsReceived = payload
  },

  // Datos Select Filtros Genrals  Emitidos
  'OPTIONS_FILTER_BUYER_GENRALS_EMIT' (state, payload) {
    state.session.optionsFilterBuyerGenralEmit = payload
  },
  'OPTIONS_FILTER_SELLER_GENRALS_EMIT' (state, payload) {
    state.session.optionsFilterSellerGenralEmit = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_GENRALS_EMIT' (state, payload) {
    state.session.optionsFilterDateCreationGenralEmit = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_GENRALS_EMIT' (state, payload) {
    state.session.optionsFilterDateIssueGenralEmit = payload
  },
  'OPTIONS_FILTER_GENRAL_NUMBER_GENRALS_EMIT' (state, payload) {
    state.session.optionsFilterGenralNumberGenralEmit = payload
  },
  'OPTIONS_FILTER_DESCRIPTION_GENRALS_EMIT' (state, payload) {
    state.session.optionsFilterDescriptionGenralEmit = payload
  },
  // Datos Select Filtros Genrals Recibidos
  'OPTIONS_FILTER_BUYER_GENRALS_RECEIVED' (state, payload) {
    state.session.optionsFilterBuyerGenralReceived = payload
  },
  'OPTIONS_FILTER_SELLER_GENRALS_RECEIVED' (state, payload) {
    state.session.optionsFilterSellerGenralReceived = payload
  },
  'OPTIONS_FILTER_DATE_CREATION_GENRALS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateCreationGenralReceived = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_GENRALS_RECEIVED' (state, payload) {
    state.session.optionsFilterDateIssueGenralReceived = payload
  },
  'OPTIONS_FILTER_GENRAL_NUMBER_GENRALS_RECEIVED' (state, payload) {
    state.session.optionsFilterGenralNumberGenralReceived = payload
  },
  'OPTIONS_FILTER_DESCRIPTION_GENRALS_RECEIVED' (state, payload) {
    state.session.optionsFilterDescriptionGenralReceived = payload
  },
  // Combo estados genrals Emitidos y Recibidos
  'OPTIONS_FILTER_STATUS_GENRALS' (state, payload) {
    state.session.optionsFilterStatusGenral = payload
  },

  // Columnas Tabla Genrals Emitidos
  'IS_SHOW_BUYER_GENRAL_EMIT' (state, payload) {
    state.local.isShowBuyerGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowBuyerGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_GENRAL_EMIT' (state, payload) {
    state.local.isShowSellerGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowSellerGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_GENRAL_EMIT' (state, payload) {
    state.local.isShowNumGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowNumGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_EMIT' (state, payload) {
    state.local.isShowDescriptionGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowDescriptionGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_GENRAL_EMIT' (state, payload) {
    state.local.isShowDateCreationGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowDateCreationGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_GENRAL_EMIT' (state, payload) {
    state.local.isShowDateIssueGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowDateIssueGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_GENRAL_EMIT' (state, payload) {
    state.local.isShowStatusGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowStatusGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_GENRAL_EMIT' (state, payload) {
    state.local.isShowServiceGenralEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowServiceGenralEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Columnas Tabla Genrals Recibidos
  'IS_SHOW_BUYER_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowBuyerGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowBuyerGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowSellerGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowSellerGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NUM_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowNumGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowNumGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DESCRIPTION_RECEIVED' (state, payload) {
    state.local.isShowDescriptionGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowDescriptionGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_CREATION_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowDateCreationGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowDateCreationGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DATE_ISSUE_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowDateIssueGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowDateIssueGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowStatusGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowStatusGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowServiceGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowServiceGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEPTION_GENRAL_RECEIVED' (state, payload) {
    state.local.isShowRecepcionGenralReceived = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.genrals.isShowRecepcionGenralReceived = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
